import { Box, Button } from '@kluein/klue-ui';
import { ArrowsDownUp, CaretDown } from '@phosphor-icons/react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from 'contexts/auth';
import TEST_IDS from 'test-ids';
import TRACKING_IDS from 'tracking-ids';

import SortDropContent from './SortDropContent';

import type { DashboardSortType } from 'api/endpoints/rivals.types';

export type SortProps = {
  onSelectSort: (sort: DashboardSortType) => void;
  sort: string | undefined;
  iconOnly?: boolean;
};
const SortDrop = (props: SortProps) => {
  const sortRef = useRef<HTMLDivElement>(null);
  const { onSelectSort, sort, iconOnly = false } = props;
  const { t } = useTranslation();
  const { isCurator } = useAuth();

  // Only redirect cards/battlecards sorts to companyDefault for consumers (curators can use all sorts)
  const shouldRedirectSort =
    !isCurator && (sort === 'cards' || sort === 'battlecards');
  const sortName = shouldRedirectSort
    ? t('Dashboard:sort.companyDefault')
    : t(`Dashboard:sort.${sort}`);

  const selectedSort = shouldRedirectSort ? 'companyDefault' : sort;

  return (
    <Box
      align="center"
      direction="row"
      ref={sortRef}
      flex={false}
      data-test-id={TEST_IDS.dashboard.filterDrops.sort.drop}
    >
      <Button
        label={iconOnly ? '' : sortName}
        dropContent={
          <SortDropContent
            sort={selectedSort}
            onSelectSort={onSelectSort}
            isCurator={isCurator}
          />
        }
        alignSelf="center"
        variant="flat"
        dropAlign="right"
        leftSlot={<ArrowsDownUp />}
        rightSlot={iconOnly ? undefined : <CaretDown />}
        data-test-id={TEST_IDS.dashboard.filterDrops.sort.dropButton}
        data-tracking-id={TRACKING_IDS.dashboard.filters.sortDrop.button}
      />
    </Box>
  );
};

export default SortDrop;
